import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
const faqs = [{
  question: '¿Tengo que tirar todo?',
  answer: 'No, aprenderás a priorizar lo más urgente. El sistema del Semáforo te guía para hacer cambios graduales, empezando por los productos más problemáticos (Rojo) y avanzando a tu ritmo.'
}, {
  question: '¿Es apto para hombres?',
  answer: 'Sí, es vital para la calidad del ADN del esperma. Los disruptores endocrinos afectan tanto la fertilidad femenina como masculina. El protocolo incluye una guía específica para ambos.'
}, {
  question: '¿Cuánto tiempo toma ver resultados?',
  answer: 'El protocolo de limpieza dura 14 días, pero muchas personas reportan sentirse mejor en la primera semana. La reducción de la carga tóxica comienza inmediatamente al eliminar las fuentes principales.'
}, {
  question: '¿En qué formato recibiré el material?',
  answer: 'Recibirás acceso inmediato a guías digitales en PDF descargables, listas de verificación imprimibles y el protocolo día por día. Todo está diseñado para ser práctico y fácil de seguir.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream py-20 md:py-28" data-id="element-38">
      <div className="max-w-3xl mx-auto px-6 md:px-8" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="text-center mb-14" data-id="element-40">
          <span className="inline-block bg-blush-soft text-blush-ink text-xs font-semibold tracking-widest uppercase px-4 py-1.5 rounded-full mb-4" data-id="element-41">
            Preguntas frecuentes
          </span>
          <h2 className="font-serif text-3xl md:text-5xl text-ink" data-id="element-42">
            Lo que querrás saber
          </h2>
        </motion.div>

        <div className="space-y-3" data-id="element-43">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            ease: 'easeOut',
            delay: index * 0.06
          }} className={`${isOpen ? 'bg-blush-soft' : 'bg-white'} rounded-2xl overflow-hidden border border-blush/30 transition-colors duration-300`} data-id="element-44">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex justify-between items-center p-6 text-left hover:bg-blush-soft/60 transition-colors duration-300" aria-expanded={isOpen} data-id="element-45">
                  <span className="font-serif text-lg md:text-xl text-ink pr-4" data-id="element-46">
                    {faq.question}
                  </span>
                  <div className={`flex-shrink-0 inline-flex items-center justify-center w-9 h-9 rounded-full ${isOpen ? 'bg-blush-deep text-white' : 'bg-blush text-blush-ink'} transition-colors duration-300`} data-id="element-47">
                    <PlusIcon className={`w-5 h-5 transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} data-id="element-48" />
                  </div>
                </button>
                <AnimatePresence initial={false} data-id="element-49">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeOut'
              }} data-id="element-50">
                      <div className="px-6 pb-6 text-ink-soft leading-relaxed" data-id="element-51">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}